import React from 'react';
import BeachStock from '../../assets/images/beach-stock.jpeg';
import * as S from './styles';
import {ImageSourcePropType, TouchableOpacity, Image} from 'react-native';
import styled from 'styled-components/native';
import Text from '../../components/Text';
import BackwardIcon from '../../assets/images/arrow-back.png';
import {useNavigation} from '@react-navigation/native';
import SelectPhotos from '../../components/bcrs/select-photos';

const Title = styled(S.Title)`
  text-align: right;
`;

const Button = styled(TouchableOpacity)`
  flex-grow: 1;
  flex: 1;
  flex-direction: row;
`;

const ButtonText = styled(Text)`
  padding: 14px 5px;
`;

const ButtonIcon = styled(Image)`
  width: 24px;
  height: 24px;
  margin: 8px 0 0 10px;
`;

export default function BCRSSelectPhotosScreen() {
  const navigation = useNavigation();

  return (
    <>
      <S.Header>
        <Button
          onPress={_ => {
            if (navigation.canGoBack()) {
              return navigation.goBack();
            }

            navigation.navigate('Root', {screen: 'Map'});
          }}>
          <ButtonIcon source={BackwardIcon} />
          <ButtonText>Back</ButtonText>
        </Button>
        <Title>Photos</Title>
      </S.Header>
      <S.Container>
        <S.Background source={BeachStock as ImageSourcePropType}>
          <SelectPhotos />
        </S.Background>
      </S.Container>
    </>
  );
}
